import React from 'react';

export default () => {
  const blogLink = 'https://mobilemonkey.com/blog';
  return (
    <div className="affiliate-panel__resources">
      <h3>Affiliate resources</h3>
      <p>
        Access your affiliate portal by following this&nbsp;
        <a
          className="affiliate-panel__external-link"
          style={{ paddingRight: 0 }}
          href="https://mobilemonkey.postaffiliatepro.com/affiliates/login.php#login"
          target="_blank"
        >
          link
        </a>
        .
      </p>
      <p>
        Join us at the{' '}
        <a
          className="affiliate-panel__external-link"
          href={blogLink}
          target="_blank"
        >
          affiliate blog
        </a>
        &nbsp;for great resources, tips, and tricks on how to promote
        MobileMonkey to your network.
      </p>
    </div>
  );
};
